// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: 'eu-west-2',
    aws_cognito_identity_pool_id: 'eu-west-2:7ed38f5d-daf0-4c16-bda6-fa7fcc523119',
    aws_cognito_region: 'eu-west-2',
    aws_user_pools_id: 'eu-west-2_aF4MNV2Rr',
    aws_user_pools_web_client_id: '4rrbigqdbfjle1qe1n0t53b3e4',
    oauth: {
        domain: 'bs-suppliers-demo.auth.eu-west-2.amazoncognito.com',
        scope: [
            'phone',
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin',
        ],
        redirectSignIn: 'http://localhost:3000/callback/',
        redirectSignOut: 'http://localhost:3000/callback/',
        responseType: 'token',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_appsync_graphqlEndpoint: 'https://a4j4gnqgjfdidaoftbuoq7wzry.appsync-api.eu-west-2.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
}


export default awsmobile
